import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=80b48b06"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=80b48b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports